import { takeLatest, all, fork, put, call, take } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* unattendEvent({ id, callbacks }) {
  try {
    const response = yield call(api.unattendEvent, id);
    yield put(Actions.fetchEventInfo(id));
    yield take([
      Actions.FETCH_EVENT_INFO_SUCCESS,
      Actions.FETCH_EVENT_INFO_FAIL,
    ]);
    yield put(Actions.unattendEventSuccess(response.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks?.success, response.data);
    }
  } catch (error) {
    yield put(Actions.unattendEventFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchUnattendEvent() {
  yield takeLatest(Actions.UNATTEND_EVENT_REQUEST, unattendEvent);
}

export default function* unattend() {
  yield all([fork(watchUnattendEvent)]);
}
